// common
const common = {
  'common.Cancel': 'Cancel',
  'common.Save': 'Save',
  'common.add': 'Add',
  'common.operation': 'Operation',
  'common.modify': 'Modify',
  'common.Edit': 'Edit',
  'common.view': 'View',
  'common.delete': 'Delete',
  'common.sureDelete': 'Are you sure to delete',
  'common.deleteSuccess': 'Delete success',
  'common.addSuccess': 'Add success',
  'common.modifySuccess': 'Modify success',
  'common.ok': 'OK',
  'common.cancel': 'Cancel',
  'common.prompt': 'Prompt',
  'common.advSearch': 'Advanced Search',
  'common.customSearch': 'Custom Search'
};

// TableData
const TableData = {
  'TableData.pleaseSelectARecord': 'Please select a record',
  'TableData.sureCancelEdit': 'Are you sure?',
  'TableData.exportAll': 'Download All Columns',
  'TableData.exportSpecify': 'Download Specify Columns',
  'TableData.exportCheck': 'Select columns to be downloaded',
  'TableData.exportInput': 'Input key words',
  'TableData.selectAll': 'Select All',
  'TableData.ok': 'OK',
  'TableData.empty': 'Empty',
  'TableData.refresh': 'Refresh',
  'TableData.advancedSearch': 'Advanced Search',
  'TableData.shrink': 'Shrink',
  'TableData.enlarge': 'Enlarge',
  'TableData.customSearch': 'Custom Search'
};

// OrgChartData
const OrgChartData = {
  'OrgChartData.setting': 'Setting',
  'OrgChartData.saveStructure': 'Save Structure',
  'OrgChartData.up': 'Up',
  'OrgChartData.down': 'Down',
  'OrgChartData.sureSaveSturcture': 'Are you sure to save structure?'
};

const ClockInPlace = {
  'ClockInPlace.sites': 'Sites for Geo-fence',
  'ClockInPlace.tips':
    'Users will be able to clock in and out within the fenced area',
  'ClockInPlace.addSite': 'ADD SITE',
  'ClockInPlace.siteAddress': 'Site address',
  'ClockInPlace.fenceSize': 'Fence size',
  'ClockInPlace.avaliableJobs': 'Avaliable jobs',
  'ClockInPlace.avaliableJobsTip':
    'Determine which jobs can be utilized in this state',
  'ClockInPlace.allActiveSitesTitile': 'All active sites map preview',
  'ClockInPlace.done': 'Done',
  'ClockInPlace.addressName': 'Address Name',
  'ClockInPlace.addressDetail': 'Address Details',
  'ClockInPlace.selectJobs': 'Select jobs',
  'ClockInPlace.tipAddressName': 'Please enter a address name',
  'ClockInPlace.tipJobs': 'Please select available jobs',
  'ClockInPlace.tipCities': 'Please select address',
  'ClockInPlace.tipAddress': 'Please select address',
};

export default {
  ...common,
  ...TableData,
  ...OrgChartData,
  ...ClockInPlace,
  add: 'add',
  edit: 'edit',
  cancel: 'cancel',
  save: 'save',
  view: 'view',
  delete: 'delete',
  choose: 'choose',
  modify: 'modify'
};
